// window.backendUrl
export const SUBSCRIBE = `/api/newsletter/subscribe`;
export const CONTACT = `/api/contact`;
export const BREADCRUMBS = `/api/breadcrumbs`;
export const SEARCH = `/api/search`;
export const ASSOCIATED_COLLEGES = `/api/associated-colleges`;